<template>
  <div class="table-responsive">
    <table class="table table-flush">
      <thead class="thead-light">
        <tr>
          <th>Title</th>
          <th>Location</th>
          <th>Create Date</th>
          <th>Type</th>
          <th class="text-center">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="!resources[0]">
          <td align="center" colspan="100%">No resources found</td>
        </tr>
        <tr v-for="resource of resources" :key="resource.id">
          <td>{{ resource.title }}</td>
          <td>{{ resource.location.name }}</td>
          <td>{{ formatDate(resource.createDate) }}</td>
          <td>{{ resource.resourceType }}</td>
          <td class="text-center">
            <button
              @click="deleteResource(resource)"
              v-if="hasRoles(['deleteResource'])"
              type="button"
              class="btn btn-sm btn-danger btn-icon-only rounded-circle mt-1"
            >
              <i class="fa fa-trash"></i>
            </button>
          </td>
        </tr>
        <tr>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
          <td class="p-0"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
window.$ = window.jQuery = require("jquery");
import firebase from "@/config/firebase.js";
import { firestorage } from "@/config/firebase.js";
require("bootstrap/dist/js/bootstrap.js");

import swal from "sweetalert2";

export default {
  name: "resources-table",
  props: {
    resources: Array
  },
  data() {
    return {
      editingResource: {}
    };
  },
  methods: {
    formatDate(date) {
      if (date) {
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December"
        ];
        const dateObj = new Date(date.seconds * 1000);

        const month = monthNames[dateObj.getMonth()];
        const day = dateObj.getDate();
        const year = dateObj.getFullYear();

        return `${month} ${day}, ${year}`;
      }

      return "No date set";
    },
    hasRoles: function(roles) {
      return roles.every(this.hasRole);
    },
    hasRole: function(role) {
      return this.rolesData[role] != null || this.isOwner;
    },
    deleteResource(resource) {
      const curOrgId = this.curOrg.id;
      const self = this;

      swal
        .fire({
          title: "Are you sure?",
          text: `You are about to delete ${resource.title}!`,
          type: "warning",
          icon: "warning",
          showCancelButton: !0,
          confirmButtonColor: "#0CC27E",
          cancelButtonColor: "#FF586B",
          confirmButtonText: "Continue",
          cancelButtonText: "Cancel",
          confirmButtonClass: "btn btn-success mr-5",
          cancelButtonClass: "btn btn-danger",
          buttonsStyling: !1
        })
        .then(
          function(result) {
            if (result.value) {
              firebase
                .firestore()
                .doc(`organizations/${curOrgId}/resources/${resource.id}`)
                .delete()
                .then(() => location.reload())
                .catch(function(error) {
                  console.error(error);
                });
            }
          },
          function(t) {
            "cancel" === t &&
              swal("Cancelled", "Your file is safe :)", "error");
          }
        );
    }
  },
  computed: {
    curOrg() {
      return this.$store.state.usermain.curOrg;
    },
    currentUser() {
      return this.$store.state.usermain.currentUser;
    },
    isOwner() {
      return this.$store.state.usermain.isOwner;
    },
    rolesData() {
      return this.$store.state.usermain.rolesData;
    }
  }
};
</script>
